import { TFunction } from 'i18next'
import ActiveDirectoryRestService from '../rest/ActiveDirectoryRestService'
import RoleService from './RoleService'

class ActiveDirectoryService {
  static async getAdConfig(setAdConfig: React.Dispatch<any>) {
    const adConfig = await ActiveDirectoryRestService.getBasicConfig()
    try {
      if (Object.keys(adConfig).length > 0) {
        const certificate: Blob = await ActiveDirectoryRestService.getCertificate()
        adConfig.certificate = certificate
      }
    } catch (error) {

    }
    setAdConfig(adConfig)
  }

  static async configureAdConfig(adConfig: any, t: TFunction, setAdConfig: React.Dispatch<any>) {
    try {
      var properties = Object.assign({}, adConfig)
      delete properties.certificate
      await ActiveDirectoryRestService.configureBasic(properties)
      var certificate = adConfig.certificate
      if (!certificate?.size) {
        certificate = undefined
      }
      const formData = new FormData()
      formData.append('certificate', certificate)
      await ActiveDirectoryRestService.configureCertificate(formData)
      await ActiveDirectoryRestService.testConnection()
      await ActiveDirectoryService.getAdConfig(setAdConfig)
      return t('adConfig.configureSuccess')
    } catch (error) {
      return Promise.reject(error)
    }
  }

  static async deleteAdConfig(t: TFunction, setAdConfig: React.Dispatch<any>) {
    try {
      await ActiveDirectoryRestService.deleteConfig()
      await ActiveDirectoryService.getAdConfig(setAdConfig)
      return t('adConfig.deleteSuccess')
    } catch (error) {
      return Promise.reject(error)
    }
  }

  static async getAdMapping(setAdMapping: React.Dispatch<any>) {
    const adMapping = await ActiveDirectoryRestService.getAdMapping()
    setAdMapping(adMapping)
  }

  static async createAdMapping(adMapping: any, t: TFunction, setAdMapping: React.Dispatch<any>) {
    try {
      await ActiveDirectoryRestService.createAdMapping(adMapping)
      await ActiveDirectoryService.getAdMapping(setAdMapping)
      return t('adMapping.createSuccess', { description: adMapping.description })
    } catch (error) {
      return Promise.reject(error)
    }
  }

  static async importAdMapping(searchBase: any, t: TFunction, setAdMapping: React.Dispatch<any>) {
    try {
      await ActiveDirectoryRestService.importAdMappings(searchBase.searchBase)
      await ActiveDirectoryService.getAdMapping(setAdMapping)
      return t('adMapping.importSuccess')
    } catch (error) {
      return Promise.reject(error)
    }
  }

  static async changeAdMapDescription(adMapping: any, t: TFunction, setAdMapping: React.Dispatch<any>) {
    try {
      await ActiveDirectoryRestService.changeAdMapDescription(adMapping.id, adMapping.description)
      await ActiveDirectoryService.getAdMapping(setAdMapping)
      return t('adMapping.editSuccess', { description: adMapping.description })
    } catch (error) {
      return Promise.reject(error)
    }
  }

  static async deleteAdMapping(adMapping: any, t: TFunction, setAdMapping: React.Dispatch<any>) {
    try {
      await ActiveDirectoryRestService.deleteMapping(adMapping.id)
      await ActiveDirectoryService.getAdMapping(setAdMapping)
      return t('adMapping.deleteSuccess', { description: adMapping.description })
    } catch (error) {
      return Promise.reject(error)
    }
  }

  static async getRolesWithAssigned(id: number) {
    const allRoles: any[] = await RoleService.get()
    const adMappingRoles: any[] = await ActiveDirectoryRestService.getAssignedRoles(id)

    const adMappingRoleIds: number[] = adMappingRoles.map((role: { id: any }) => role.id)
    allRoles.forEach((role) => {
      if (adMappingRoleIds.includes(role.id)) {
        role.isAssigned = true
      } else {
        role.isAssigned = false
      }
    })
    return allRoles
  }

  static async assignRoles(roles: any[], adMapping: any, t: TFunction) {
    await ActiveDirectoryRestService.updateAssignedRoles(
      adMapping.id,
      roles.filter((role) => role.isAssigned).map((role) => role.id)
    )
    return t('adMapping.assignRolesSuccess', { description: adMapping.description })
  }
}

export default ActiveDirectoryService
